import { GET_ERRORS } from "redux/actions/types";

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ERRORS:
      return action.payload ?? state;
    default:
      return state;
  }
}